import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import styles from './GameSlider.module.scss';

const GameSlider = ({ jeux = [], onSelect }) => {
  return (
    <div className={styles.sliderContainer}>
      <Swiper 
        modules={[Navigation]}
        navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }}
        spaceBetween={10} 
        slidesPerView={1}
      >
        {jeux.map((jeu) => (
          <SwiperSlide key={jeu.id} style={{ width: '100%' }}>
            <div
              className={styles.slide}
              onClick={() => onSelect(jeu.id)}
              style={{
                backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url(${jeu.image})`,
              }}
            >
              <p className={styles.title}>{jeu.nom}</p>
              {(jeu.entreprise || jeu.adresse) && (
                <p className={styles.entInfos}>
                  {jeu.entreprise && <span className={styles.bold}>{jeu.entreprise}</span>}
                  {jeu.entreprise && jeu.adresse && ' - '}
                  {jeu.adresse && <span>{jeu.adresse}</span>}
                </p>
              )}

              {/* Réservation : affiche le libellé seulement si tel ou email existe */}
              {(jeu.telephone || jeu.email) && (
                <p className={styles.entInfos}>
                  Réservation :{' '}
                  {jeu.telephone && <span className={styles.bold}>{jeu.telephone}</span>}
                  {jeu.telephone && jeu.email && ' - '}
                  {jeu.email && <span className={styles.bold}>{jeu.email}</span>}
                </p>
              )}
              {/* <p className={styles.freeLabel}>Gratuit</p> */}
            </div>
          </SwiperSlide>
        ))}

        {/* Flèches customisées */}
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </Swiper>
    </div>
  );
};

export default GameSlider;
